import React from 'react';
import { useCommunityQuestionLink } from "../../../../hooks/useCommunityQuestionLink";
import Section, { SectionsWrapper, TwoColumns } from "../../../Section";
import SupportContact from "./SupportContact";
import SupportResources from "./SupportResources";
import SupportTagline from "./SupportTagline";
const SupportTab = props => {
  const {
    supportDetails,
    atlassianCommunityBaseUrl,
    mpacBaseUrl,
    hosting,
    appKey,
    onSupportLinkClick
  } = props;
  const communityQuestionLink = useCommunityQuestionLink({
    atlassianCommunityBaseUrl,
    mpacBaseUrl,
    appKey,
    hosting
  });
  return /*#__PURE__*/React.createElement(SectionsWrapper, null, /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(SupportTagline, {
    supportDetails: supportDetails
  })), /*#__PURE__*/React.createElement(TwoColumns, null, /*#__PURE__*/React.createElement(TwoColumns.Left, null, /*#__PURE__*/React.createElement(SupportResources, {
    supportDetails: supportDetails,
    communityQuestionLink: communityQuestionLink,
    onSupportLinkClick: onSupportLinkClick
  })), /*#__PURE__*/React.createElement(TwoColumns.Right, null, /*#__PURE__*/React.createElement(SupportContact, {
    onSupportLinkClick: onSupportLinkClick,
    supportDetails: supportDetails
  }))));
};
export default SupportTab;